import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import { formatKoreanPhone } from '@constants/regexp';
import styled from '@emotion/styled';
import useCopyShopAddress from '@hooks/shop/useCopyShopAddress';
import useAppCustom from '@hooks/useAppCustom';
import Copy from '@icons/Copy';
import { ShopResponse } from '@models/shop';
import { pressActionEffect } from '@styles/mixin';
import { openExternalLink } from '@utils/nativeUtils';
import { useTranslation } from 'react-i18next';

interface Props {
    shop?: ShopResponse;
}

/** 매장명, 주문 확인 문구, 주소와 전화번호 */
function ShopInfo({ shop }: Props) {
    const { t } = useTranslation('shopLocation');
    const copyAddress = useCopyShopAddress(shop?.address);
    const { usePhoneNumber } = useAppCustom().shop;
    return (
        <>
            <Column align='center'>
                <BreakText size='display' fontWeight='bold' align='center'>
                    {shop?.name}
                </BreakText>
                <Text size='display' align='center'>{t('title')}</Text>
            </Column>
            <Column align='center' spacing={1}>
                <Row spacing={2} onClick={copyAddress} css={pressActionEffect}>
                    <BreakText size='body-long' color='var(--color-text-secondary)' align='center'>
                        {shop?.address}
                    </BreakText>
                    <Copy color='var(--color-gray7)' size={16}/>
                </Row>
                {(shop?.phoneNumber && usePhoneNumber) && (
                    <PhoneText size='body-long'
                        color='var(--color-text-secondary)'
                        onClick={() => openExternalLink(`tel:${shop.phoneNumber}`)}>
                        {formatKoreanPhone(shop.phoneNumber)}
                    </PhoneText>
                )}
            </Column>
        </>
    );
}

const BreakText = styled(Text)`
    word-break: break-word;
`;

const PhoneText = styled(Text)`
    cursor: pointer;
    text-decoration: underline;
`;

export default ShopInfo;
